/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostDestinationPathParams = NonNullable<operations['postDestination']['parameters']['path']>;

export type PostDestinationRequestBody = OperationRequestBodyContent<operations['postDestination']>;

export interface Input extends PostDestinationPathParams {
  apiVersion?: string;
  body: PostDestinationRequestBody;
}

export async function postDestination(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/destinations/{projectKey}/{environmentKey}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
